import React, { useCallback, useState, useEffect } from "react";
import Particles from "react-tsparticles";
import particlesOptions from "./particles.json";
import { loadFull } from "tsparticles";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Footer from "./components/Footer";
import Fixed from "./components/Fixed";
import GoTop from "./components/GoTop";
import { HiSun, HiMoon } from "react-icons/hi";
import FadeLoader from "react-spinners/FadeLoader";
import "./App.css";

function App() {
  const particlesInit = useCallback((main) => {
    loadFull(main);
  }, []);
  const [navbar, setNavbar] = useState(false);
  const changeStyle = () => {
    if (window.scrollY > 600) setNavbar(true);
    else setNavbar(false);
  };

  const [darkMode, setDarkMode] = useState(false);
  const [loading, setLoading] = useState(false);
  window.addEventListener("scroll", changeStyle);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, []);
  return (
    <div className={`${darkMode ? "dark" : ""} text-white w-full h-full  `}>
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <FadeLoader
            height={15}
            width="5px"
            radius={2}
            margin="2px"
            color="#1AE449"
          />
        </div>
      ) : (
        <>
          <button
            className="fixed  top-14 right-[0.6rem] md:top-20 dark:text-white text-black z-50 ease-in-out duration-1000"
            onClick={() => setDarkMode((prev) => !prev)}
          >
            {darkMode ? (
              <HiSun size={40} className="text-yellow-400" />
            ) : (
              <HiMoon size={40} className="text-[#a4a4a4]" />
            )}
          </button>
          <Particles options={particlesOptions} init={particlesInit} />

          <div className="dark:bg-black ease-in-out duration-1000  ">
            <Navbar navbar={navbar} />
            <Hero />
            <Fixed />
            <About />
            <Skills />
            <Projects />
            <Footer />
            <GoTop navbar={navbar} />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
